module.exports = __webpack_public_path__ + "static/media/br1909.71e28808.png";